<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <v-card class="h-100 pa-8" :loading="isLoading">
      <SoAlert
        v-if="bookingFailed"
        ref="error-alert"
        title="Sorry, the booking failed"
        type="error"
        class="mb-6"
      >
        <p class="mt-3">
          Please try again. Alternatively, the customer can book an appointment
          via their online account.
        </p>
      </SoAlert>
      <div
        v-if="bookingSuccessful && imbpBookingInformation.data?.latestBooking"
      >
        <SoAlert
          ref="success-alert"
          title="Smart meter installation booked successfully"
          type="success"
          class="mb-6"
        >
        </SoAlert>
        <p class="mt-10 mb-8 text-h6">
          The customer will receive confirmation via email and text message.
        </p>
        <ul class="ml-10">
          <li class="mb-1 text-h6">
            Booking reference:
            {{ imbpBookingInformation.data.latestBooking.displayJobNumber }}
          </li>
          <li class="mb-1 text-h6">Address: {{ address }}</li>
          <li class="mb-1 text-h6">
            Date: {{ imbpBookingInformation.data.latestBooking.dateFormatted }}
          </li>
          <li class="mb-5 text-h6">
            Time:
            {{ imbpBookingInformation.data.latestBooking.timeSlotFormatted }}
          </li>
        </ul>
      </div>
      <SoButton
        v-if="!isLoading"
        class="mt-6"
        :title="buttonTitle"
        type="success"
        large
        :to="{ name: 'CustomerImbp' }"
      />
    </v-card>

    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import { formatDate, formatTimeSlot } from "@/helpers/dateHelper"
  import { ImbpService } from "@/services/ImbpService"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoButton,
      SoAlert,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        formatDate,
        formatTimeSlot,
      }
    },
    computed: {
      bookingSuccessful() {
        return this.current.recentImbpChange.isSuccess
      },
      bookingFailed() {
        return this.current.recentImbpChange.isError
      },
      isLoading() {
        return (
          this.current.account.isLoading ||
          this.imbpBookingInformation.isLoading ||
          this.current.recentImbpChange.isLoading
        )
      },
      imbpBookingInformation() {
        return ImbpService.getBookingInformation(
          this.current.imbpAccount.data.billingAccountId,
        )
      },
      address() {
        return `${this.imbpBookingInformation.data?.latestBooking?.address}, ${this.imbpBookingInformation.data?.latestBooking?.postcode}`
      },
      buttonTitle() {
        return this.bookingFailed ? "Try again" : "View bookings"
      },
    },
    watch: {
      bookingSuccessful(success) {
        if (success) {
          ImbpService.getBookingInformation(
            this.current.imbpAccount.data.billingAccountId,
          ).refetch()
        }
      },
    },
    methods: {
      viewBookings() {
        this.$router.push({
          name: "CustomerImbp",
        })
      },
    },
  })
</script>
